module.exports = __webpack_public_path__ + "img/bg_01.97ca22e3.jpg";